export const ROUTES = [
  { path: "/", value: "Inicio" },
  { path: "/proyectos", value: "Proyectos" },
  { path: "/soluciones", value: "Soluciones" },
  { path: "/cursos", value: "Cursos" },
  { path: "/articulos", value: "Artículos" },
  { path: "/sobre", value: "Sobre Codealo" },
];